import { init } from '@plausible-analytics/tracker';

const { PLAUSIBLE_DOMAIN } = window;

if (PLAUSIBLE_DOMAIN) {
    init({
        domain: PLAUSIBLE_DOMAIN,
        outboundLinks: true,
        fileDownloads: true,
        formSubmissions: true,
    });
}
